import ApiInfo from './Api/ApiInfo'
import Folder from './Api/Folder'
import './Api.sass'

const Api = (props) => {
    
    const isApi = (props) => {
        return props.info && props.item.length > 0
    }

    if(isApi(props)){
        return <>
            <ApiInfo {...props}/>
            <h2 className="mt-5">Requests</h2>
            {props.item.map((o, i)=><Folder key={i} {...o}/>)}
        </>
    }
    else return null
}
export default Api